import React, { useReducer, useEffect, useContext} from "react";
import checklistContext from "./consumosContext.js";
import {createPDF, getAllConsumos, getConsumosByFilter, getConsumosById} from '../../api/consumos.js'
import checklistReducer from "./consumosReducer.js";

import { ACTUALIZAR_LIST_CONSUMOS } from "./consumosActions.js";

import { SocketContext } from "../socket/socket.js";
import authContext from "../authentication/authContex.js";
import { Buffer } from "buffer";

const ConsumosState = props =>{

    const server = useContext(SocketContext);

    const initialState = {
        consumosList: [],
        checklistRegList: []
     };

    const [state, dispatch] = useReducer(checklistReducer, initialState);
    const auContext = useContext(authContext);
    const {usuario, verificarTenant} = auContext;


    const actualizarConsumos = async () => {
        try{
            const resp = await getAllConsumos();
            const checklist = resp.data.data;
            dispatch({
                type: ACTUALIZAR_LIST_CONSUMOS,
                payload: checklist
            });
            return checklist;
        }catch(err){
            console.log(err)
            return err;
        }
    };

    const eliminarConsumo = async (checklist) => {
        try{
            console.log("eliminarConsumo");
            return true;
        }catch(err){
            console.log(err)
        }
    }

    const getConsByID = async(consID) =>{
        try {
            let res = await getConsumosById(consID);
            return res;
        } catch (error) {
            console.log(error.message);
            return error.message;
        }
    } 

    function openBase64PDF(base64String) {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });

        const fileUrl = URL.createObjectURL(blob);
        window.open(fileUrl);
    }

    const generarInformeReqPDF = async (tDoc, usuario) => {
        try {
            const resp = await createPDF(tDoc.tDocCodFor, tDoc.tDocNroFor, usuario._id);//clienteAxios.post('/transactionDocument/informe', { tDocCodFor: tDoc.tDocCodFor, tDocNroFor: tDoc.tDocNroFor, userId: usuario._id });
            const buff = Buffer.from(resp.data, "base64");
            const base64 = buff.toString("base64");
            openBase64PDF(base64);
        } catch (error) {
            console.log(error);
            console.log("Error en generar informe requerimiento PDF");
        }
    }

    /* 
        Disparadores que sincronizan la lista de checklists ante la modificacion de uno.
    */
    useEffect(() => {
        if(server){
            //TDoc Nuevo
            server.on('addConsumo', ({tenantId}) => {
                const update = verificarTenant(tenantId);
                if(update){
                    console.log("RealTimeServer indico que un checklist a sido modificado, actualizando lista de checkslist...");
                    actualizarConsumos();
                }
            });
            return () => server.off('addConsumo');
        }
    },[server]);

    useEffect(() => {
        if(usuario != null) actualizarConsumos();
    },[usuario])


    return(
        <checklistContext.Provider
            value={{
                consumosList: state.consumosList,
                actualizarConsumos:actualizarConsumos,
                getConsByID,
                eliminarConsumo,
                generarInformeReqPDF
            }}
        >
            {props.children}
        </checklistContext.Provider>
    )

}

export default ConsumosState;